import { render, staticRenderFns } from "./batchDisposePop.vue?vue&type=template&id=28d6010f&scoped=true&"
import script from "./batchDisposePop.vue?vue&type=script&lang=js&"
export * from "./batchDisposePop.vue?vue&type=script&lang=js&"
import style0 from "./batchDisposePop.vue?vue&type=style&index=0&id=28d6010f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d6010f",
  null
  
)

export default component.exports